// This file is part of Moodle - http://moodle.org/
//
// Moodle is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// Moodle is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Moodle.  If not, see <http://www.gnu.org/licenses/>.
/**
 * Events of reports.
 *
 * @package     local_edwiserreports
 * @copyright   2021 wisdmlabs <support@wisdmlabs.com>
 * @license     http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */
define([], function() {
    // Prefix for all events.
    let prefix = 'edwiserreports:';

    // Events list.
    return {
        DATECHANGE: prefix + 'datechange',
        EXPORTGRAPHPDF: prefix + 'exportgraphpdf',
        EXPORTGRAPHPNG: prefix + 'exportgraphpng',
        EXPORTGRAPHJPEG: prefix + 'exportgraphjpeg',
        EXPORTGRAPHSVG: prefix + 'exportgraphsvg',
    };
})
